<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent sp-margin__bottom-x2">
      {{ 'COMPANIES.ARCHIVE_NOTE_DIALOG_TITLE' | translate }}
    </h3>

    <form [formGroup]="company_archive_note_form_group">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.CHANGE_REASON_LABEL' | translate }}
        </mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="note"
          [errorStateMatcher]="error_matcher"
          required></textarea>
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_archive_note_running"
        [is_spinner_visible]="is_archive_note_running"
        (click)="onArchiveNoteClick()"></app-shared-button>
    </form>
  </div>
</div>
